import { consultantSharedStyles, datePickerFieldStyles, profileSharedStyles } from '../shared/styles';
import { adminPagesSharedStyles, BORDER, createAdminPageStyles, MUTED, NAVY, TEXT } from '../style';

export const useStyles = createAdminPageStyles({
  ...consultantSharedStyles,
  ...profileSharedStyles,
  phoneValue: {
    display: 'inline-flex',
    alignItems: 'center',
    gap: 8,
  },
  flag: {
    width: 22,
    height: 14,
    objectFit: 'cover',
    borderRadius: 2,
    display: 'block',
  },
  emptyTab: {
    fontFamily: 'Poppins',
    fontSize: 14,
    color: MUTED,
    padding: '8px 0',
  },
  resultsToolbar: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    gap: 16,
    marginBottom: 28,
    flexWrap: 'wrap',
  },
  resultsSearch: {
    width: 280,
    maxWidth: '100%',
    '& .MuiOutlinedInput-root': {
      borderRadius: 8,
      fontFamily: 'Poppins',
      fontSize: 14,
      minHeight: 44,
      background: '#FFFFFF',
    },
    '& .MuiOutlinedInput-notchedOutline': {
      borderColor: BORDER,
    },
  },
  compassBtn: {
    background: '#FFFFFF',
    color: TEXT,
    border: `1.5px solid ${BORDER}`,
    textTransform: 'none',
    fontFamily: 'Poppins',
    fontWeight: 600,
    fontSize: 14,
    borderRadius: 8,
    padding: '10px 16px',
    boxShadow: 'none',
    '&:hover': {
      background: '#F7F8FB',
      boxShadow: 'none',
    },
  },
  resultsSection: {
    marginBottom: 32,
  },
  resultsSectionTitle: {
    fontFamily: 'Poppins',
    fontSize: 20,
    fontWeight: 500,
    color: '#333333',
    margin: '0 0 12px',
  },
  resourceTable: {
    tableLayout: 'fixed',
  },
  colName: {
    width: '34%',
  },
  colDate: {
    width: '22%',
  },
  colStatus: {
    width: '12%',
  },
  colAction: {
    width: '16%',
  },
  colTestName: {
    width: '50%',
  },
  colTestDate: {
    width: '30%',
  },
  colTestAction: {
    width: '28%',
  },
  nameCell: {
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    whiteSpace: 'nowrap',
  },
  resultCell: {
    textAlign: 'center',
    whiteSpace: 'nowrap',
  },
  testResultCell: {
    width: '100%',
  },
  testResultActions: {
    display: 'flex',
    alignItems: 'center',
    gap: 8,
    width: '100%',
  },
  resultBtn: {
    background: '#FFFFFF',
    color: NAVY,
    border: `1.5px solid ${NAVY}`,
    textTransform: 'none',
    fontFamily: 'Poppins',
    fontWeight: 600,
    fontSize: 13,
    borderRadius: 6,
    padding: '6px 14px',
    minWidth: 0,
    boxShadow: 'none',
    margin: '0 4px',
    '&:hover': {
      background: '#F7F8FB',
      boxShadow: 'none',
    },
  },
  testResultBtn: {
    background: '#FFFFFF',
    color: NAVY,
    border: `1.5px solid ${NAVY}`,
    textTransform: 'none',
    fontFamily: 'Poppins',
    fontWeight: 600,
    fontSize: 13,
    borderRadius: 8,
    padding: '8px 12px',
    minWidth: 0,
    flex: '1 1 0',
    width: '100%',
    boxShadow: 'none',
    '&:hover': {
      background: '#F7F8FB',
      boxShadow: 'none',
    },
  },
  lectureTag: {
    display: 'inline-flex',
    alignItems: 'center',
    justifyContent: 'center',
    borderRadius: 8,
    padding: '6px 8px',
    fontFamily: 'Poppins',
    fontSize: 12,
    fontWeight: 600,
    lineHeight: 1.2,
    whiteSpace: 'nowrap',
  },
  lectureRead: {
    background: '#D4F8D3',
    color: '#478145',
  },
  lectureUnread: {
    background: '#EAE9EA',
    color: '#838183',
  },
  adminCell: {
    textAlign: 'center',
    fontWeight: 400,
  },
  textField: {
    ...adminPagesSharedStyles.textField,
    ...datePickerFieldStyles.textField,
  },
  datePickerBtn: datePickerFieldStyles.datePickerBtn,
  passwordDialog: {
    '& .MuiDialog-paper': {
      borderRadius: 12,
      maxWidth: 560,
      width: '100%',
      margin: 16,
      padding: '28px 32px 24px',
      boxShadow: '0 16px 40px rgba(14, 18, 71, 0.18)',
    },
  },
  passwordDialogHeader: {
    display: 'flex',
    alignItems: 'flex-start',
    justifyContent: 'space-between',
    gap: 16,
    marginBottom: 12,
  },
  passwordDialogTitle: {
    fontFamily: 'Poppins',
    fontSize: 20,
    fontWeight: 600,
    color: '#000B33',
    margin: 0,
    lineHeight: 1.3,
  },
  passwordDialogClose: {
    margin: '-8px -8px 0 0',
    color: TEXT,
    padding: 6,
  },
  passwordDialogText: {
    fontFamily: 'Poppins',
    fontSize: 15,
    fontWeight: 400,
    color: TEXT,
    lineHeight: 1.5,
    margin: '0 0 24px',
  },
  passwordFieldLabel: {
    display: 'block',
    fontFamily: 'Poppins',
    fontSize: 14,
    fontWeight: 700,
    color: TEXT,
    marginBottom: 8,
  },
  passwordRow: {
    display: 'flex',
    alignItems: 'stretch',
    gap: 10,
    marginBottom: 24,
    '@media (max-width: 600px)': {
      flexDirection: 'column',
    },
  },
  passwordInput: {
    flex: 1,
    fontFamily: 'Poppins',
    fontSize: 14,
    '& .MuiOutlinedInput-root': {
      borderRadius: 8,
      fontFamily: 'Poppins',
      fontSize: 15,
      background: '#FFFFFF',
      minHeight: 48,
    },
    '& .MuiOutlinedInput-notchedOutline': {
      borderColor: BORDER,
    },
    '& .MuiOutlinedInput-input': {
      padding: '13px 14px',
    },
    '& input::placeholder': {
      fontFamily: 'Poppins',
      fontSize: 14,
      fontWeight: 400,
      color: '#333333',
    },
    '& input': {
      fontFamily: 'Poppins',
    },
  },
  copyPasswordBtn: {
    background: '#000A8D',
    color: '#FFFFFF',
    textTransform: 'none',
    fontFamily: 'Poppins',
    fontWeight: 500,
    fontSize: 14,
    borderRadius: 8,
    padding: '10px 16px',
    whiteSpace: 'nowrap',
    boxShadow: 'none',
    minHeight: 48,
    '&:hover': {
      background: '#1b2158',
      boxShadow: 'none',
    },
    '& span': {
      fontFamily: 'Poppins',
    },
  },
  closePasswordBtn: {
    width: '100%',
    background: '#FFFFFF',
    color: TEXT,
    border: `1.5px solid ${BORDER}`,
    textTransform: 'none',
    fontFamily: 'Poppins',
    fontWeight: 500,
    fontSize: 15,
    borderRadius: 8,
    padding: '12px 16px',
    boxShadow: 'none',
    '&:hover': {
      background: '#F7F8FB',
      boxShadow: 'none',
    },
    '& span': {
      fontFamily: 'Poppins',
    },
  },
});
